import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Necesito saber de Montessori?',
  answer: 'No. Está pensado para empezar desde cero, explicado de forma simple y clara.'
}, {
  question: '¿Sirve para todas las edades?',
  answer: 'Sí. Desde bebés hasta niños de 6 años.'
}, {
  question: '¿Es solo teoría?',
  answer: 'No. Es 100% aplicable a situaciones reales del día a día.'
}, {
  question: '¿Es digital?',
  answer: 'Sí. Accedés inmediatamente luego de la compra.'
}, {
  question: '¿Necesito materiales especiales?',
  answer: 'No. Se trabaja con objetos simples que ya tenés en casa.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#F5EDE4] py-16 px-4" data-id="element-90">
      <div className="max-w-3xl mx-auto" data-id="element-91">
        <h2 className="text-2xl sm:text-3xl font-bold text-[#5C4033] mb-10 text-center" data-id="element-92">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-93">
          {faqs.map((faq, index) => <div key={index} className="bg-[#FDF8F3] rounded-xl border border-[#E0D5C8] overflow-hidden" data-id="element-94">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-[#F5EDE4] transition-colors" data-id="element-95">
                <span className="font-semibold text-[#5C4033]" data-id="element-96">
                  {faq.question}
                </span>
                <motion.span animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.2
            }} data-id="element-97">
                  <ChevronDownIcon className="w-5 h-5 text-[#8B7355]" data-id="element-98" />
                </motion.span>
              </button>
              <AnimatePresence data-id="element-99">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-100">
                    <div className="px-6 pb-6 text-[#8B7355]" data-id="element-101">{faq.answer}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}